import { React, useState } from "react";
import "./FeedbackForm.scss";
import { useTranslation } from "react-i18next";
import { devLog } from "utils/devLog";
export default function FeedbackForm(props) {
  const { t } = useTranslation();

  const [valComment1, setValComment1] = useState("");

  const [q1Index, setQ1Index] = useState(0);
  const [q2Index, setQ2Index] = useState(0);
  const [q3Index, setQ3Index] = useState(0);
  const partnerCode = props.currState.localGroup;

  const [q1Required, setQ1Required] = useState(false);

  const handleSubmit = () => {
    devLog("Sending values:", q1Index, q2Index, q3Index, valComment1);

    setQ1Required(!q1Index);
    if (!q1Index) {
      return;
    }
    props.callBackFunc({
      recommendation: q1Index,
      servProvCourtesy: q2Index,
      servQuality: q3Index,
      comment1: valComment1,
    });
  };

  const btnRateOnClick = (question, selectedIndex) => {
    if (question === 1) {
      setQ1Index(selectedIndex);
      if (selectedIndex) {
        setQ1Required(false);
      }
    } else if (question === 2) {
      setQ2Index(selectedIndex);
    } else if (question === 3) {
      setQ3Index(selectedIndex);
    }
  };

  return (
    <div className="feedbackForm">
      <h3 className="feedbackForm-header px-2">{t("description.FeedbackText1")}</h3>
      <hr />
      {/* Question 1 */}
      <div className="feedback-question">
        <p className="question">
          {partnerCode === "MER" ? t("description.FeedbackQuestion1MER") : t("description.FeedbackQuestion1")}
        </p>
        <div className="ratings-wrapper">
          <div>
            <div
              className={`answerStyle rating-1 ${q1Index === 1 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(1, 1)}
            >
              1
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelyDissatisfied") : t("description.FeedbackScaleBad")}
            </div>
          </div>

          <div
            className={`answerStyle rating-2 ${q1Index === 2 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(1, 2)}
          >
            2
          </div>
          <div
            className={`answerStyle rating-3 ${q1Index === 3 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(1, 3)}
          >
            3
          </div>
          <div
            className={`answerStyle rating-4 ${q1Index === 4 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(1, 4)}
          >
            4
          </div>
          <div>
            <div
              className={`answerStyle rating-5 ${q1Index === 5 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(1, 5)}
            >
              5
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelySatisfied") : t("description.FeedbackScaleGood")}
            </div>
          </div>
        </div>

        <div style={{ textAlign: "center" }}>
          {q1Required ? <span className="required">Please make a selection</span> : <></>}
        </div>
      </div>
      {/* Question 2 */}
      <div className="feedback-question">
        <p className="question">
          {partnerCode === "MER" ? t("description.FeedbackQuestion2MER") : t("description.FeedbackQuestion2")}
        </p>
        <div className="ratings-wrapper">
          <div>
            <div
              className={`answerStyle rating-1 ${q2Index === 1 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(2, 1)}
            >
              1
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelyDissatisfied") : t("description.FeedbackScaleBadAlt")}
            </div>
          </div>

          <div
            className={`answerStyle rating-2 ${q2Index === 2 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(2, 2)}
          >
            2
          </div>
          <div
            className={`answerStyle rating-3 ${q2Index === 3 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(2, 3)}
          >
            3
          </div>
          <div
            className={`answerStyle rating-4 ${q2Index === 4 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(2, 4)}
          >
            4
          </div>
          <div>
            <div
              className={`answerStyle rating-5 ${q2Index === 5 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(2, 5)}
            >
              5
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelySatisfied") : t("description.FeedbackScaleGoodAlt")}
            </div>
          </div>
        </div>
      </div>
      {/* Question 3 */}
      <div className="feedback-question">
        <p className="question">
          {partnerCode === "MER" ? t("description.FeedbackQuestion3MER") : t("description.FeedbackQuestion3")}
        </p>
        <div className="ratings-wrapper">
          <div>
            <div
              className={`answerStyle rating-1 ${q3Index === 1 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(3, 1)}
            >
              1
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelyDissatisfied") : t("description.FeedbackScaleBadAlt")}
            </div>
          </div>
          <div
            className={`answerStyle rating-2 ${q3Index === 2 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(3, 2)}
          >
            2
          </div>
          <div
            className={`answerStyle rating-3 ${q3Index === 3 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(3, 3)}
          >
            3
          </div>
          <div
            className={`answerStyle rating-4 ${q3Index === 4 ? "selected" : ""}`}
            onClick={() => btnRateOnClick(3, 4)}
          >
            4
          </div>
          <div>
            <div
              className={`answerStyle rating-5 ${q3Index === 5 ? "selected" : ""}`}
              onClick={() => btnRateOnClick(3, 5)}
            >
              5
            </div>
            <div className="scaleLabel">
              {partnerCode === "MER" ? t("description.ExtremelySatisfied") : t("description.FeedbackScaleGoodAlt")}
            </div>
          </div>
        </div>
      </div>

      <div className="feedback-question">
        <p className="question">{partnerCode === "MER" ? t("description.ExperienceNotes") : ""}</p>
        {/* Enter Feedback Question */}
        {(true ||
          (q1Index <= 2 && q1Index !== 0) ||
          (q2Index <= 2 && q2Index !== 0) ||
          (q3Index <= 2 && q3Index !== 0)) && (
          <div style={{ display: "flex" }}>
            <textarea
              style={{ border: "1px solid rgb(182,182,182" }}
              className="hiddenCommentary"
              value={valComment1}
              rows={3}
              maxLength={225}
              placeholder="Give us Feedback!"
              onChange={(e) => {
                setValComment1(e.target.value);
              }}
            />
          </div>
        )}
      </div>

      <div className="feedbackForm-footer">
        <button onClick={handleSubmit} className="ui-btn">
          {t("description.FeedbackSubmit")}
        </button>
      </div>
    </div>
  );
}
